var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup4422(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 158.97,
    height: 74.317,
    viewBox: "0 0 158.97 74.317",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2652",
    "data-name": "Rectangle 2652",
    width: 102.248,
    height: 74.317,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4422",
    "data-name": "Group 4422",
    transform: "translate(-1213.513 -3536.412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4273",
    "data-name": "Group 4273",
    transform: "translate(1241.876 3536.412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4272",
    "data-name": "Group 4272",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1332",
    "data-name": "Path 1332",
    d: "M65.837,0H42.923V59.247q8.362,0,16.724-.039,4.224-.017,8.447-.039c4.267-.022,10.474-.731,13.123,3.47q0-.655,0-1.309V15.586A15.483,15.483,0,0,0,65.837,0",
    transform: "translate(-32.539)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1333",
    "data-name": "Path 1333",
    d: "M33.3,97.1H8.061a2.477,2.477,0,0,1-2.374-2.374V43.734H.01V98.17c0,1.7.011,3.4-.01,5.107,7.34-.088,14.676-.159,22.016-.152,7.054.007,14.114-.362,20.916,1.811a32.561,32.561,0,0,1,5.9,2.535v-.929C48.884,100.865,46.2,97.1,33.3,97.1",
    transform: "translate(0 -33.154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1334",
    "data-name": "Path 1334",
    d: "M241.146,43.734c-10.941,0-19.663,7.071-19.663,15.483v48.048c5.522-4.284,14.76-4.284,19.663-4.284h29V43.734Zm6.105,44.985H233.935a2.193,2.193,0,1,1,0-4.387h13.317a2.193,2.193,0,1,1,0,4.387M253.54,74.4a2.193,2.193,0,0,1-2.193,2.193H233.935a2.193,2.193,0,1,1,0-4.387h17.412A2.193,2.193,0,0,1,253.54,74.4Zm7.319-9.929H233.935a2.193,2.193,0,1,1,0-4.387h26.925a2.193,2.193,0,1,1,0,4.387",
    transform: "translate(-167.902 -33.154)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4421",
    "data-name": "Group 4421",
    transform: "translate(3.683 30.09)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_7",
    "data-name": "Union 7",
    d: "M5.475,8.673,0,7.088,5.475,5.5,7.081,0l1.6,5.5L14.16,7.088,8.685,8.673l-1.6,5.5Z",
    transform: "translate(1349.513 3511)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_8",
    "data-name": "Union 8",
    d: "M1.983,3.141,0,2.567l1.983-.574L2.564,0l.581,1.993,1.982.574L3.145,3.14,2.564,5.133Z",
    transform: "translate(1363.673 3523.443)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4420",
    "data-name": "Group 4420",
    transform: "translate(3 11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_14",
    "data-name": "Union 14",
    d: "M-2151.6,8.558l-5.4-1.564,5.4-1.564L-2150.014,0l1.583,5.43,5.4,1.564-5.4,1.564-1.583,5.43Z",
    transform: "translate(3367.514 3556.576)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_11",
    "data-name": "Union 11",
    d: "M-2153.644,5.317-2157,4.345l3.357-.972L-2152.66,0l.984,3.374,3.356.972-3.356.972-.984,3.374Z",
    transform: "translate(3376.806 3569.225)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup4422);
export default __webpack_public_path__ + "static/media/Group 4422.7955f0289ce61ef14f9771addbf22f08.svg";
export { ForwardRef as ReactComponent };